export default "__VITE_ASSET__MZurndd7__";